import { Component, Inject, Input, OnInit } from '@angular/core';
import { InstructionService } from '../../services/instruction.service';
import { StudyNavigationService } from '../../services/study-navigation.service';

@Component({
    selector: 'app-image-full',
    templateUrl: './image-full.component.html',
    styleUrls: ['./image-full.component.scss'],
    standalone: false
})
export class ImageFullComponent implements OnInit {
  @Input() instruction: string;
  @Input() section: string;
  @Input() label: string;
  @Input() isPractice = true;
  baseImgUrl = '/assets/images';

  imageToShow: string = null;

  constructor(
    private navigationService: StudyNavigationService,
    private instructionService: InstructionService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    this.baseImgUrl = `${this.baseUrl}assets/images`;

    const instructionInfo = this.instructionService.getInstructions('EN')[this.instruction];

    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm('MEDIA_CONTINUE_BUTTON');
    }

    const { brandImage, brandImageUrl } = this.navigationService.getBrandImage(this.isPractice ? 'practice' : 'IAT');

    if (brandImage) {
      if (!brandImageUrl) this.imageToShow = `${this.baseImgUrl}/${brandImage}`;
      else this.imageToShow = brandImageUrl;
      // TODO: Check code
      // eslint-disable-next-line no-prototype-builtins
    } else if (instructionInfo.hasOwnProperty('image')) {
      this.imageToShow = `${this.baseImgUrl}/${instructionInfo['image']}`;
    } else {
      this.imageToShow = `${this.baseImgUrl}/brand_practice.jpeg`;
    }
  }
}
